import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ breakpoints, palette, spacing,variables }) => ({
  '@global':{
    ['@media only screen and (max-width:759px)']: {
     '.footer_section':{
        display:'none'
     }
    }
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    height: 'calc(100vh - 134px)',
    [breakpoints.down('xs')]: {
      minHeight: '0px',
      flexGrow:1,
    },
    '&.pwaWrapper': {
      height: 'calc(100vh - 56px)'
    }
  },
  fixedNavigationBlock: {
    boxShadow: variables?.elevation01,
    position: 'fixed',
    zIndex: 999,
    bottom: 0,
    left: 0,
    width: '100%',
    padding: spacing(2),
    backgroundColor: palette.jet?.containerDefault,
  },
}));

export default styles;
